import { styled } from "@mui/material";
import { Typography } from "@mui/material";

export const StyledBoldText = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  textAlign: "center",
  [theme.breakpoints.up("xs")]: {
    fontSize: "16px",
  },
  [theme.breakpoints.between('lg', 'xl')]: {
    fontSize: "20px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: "25px",
  },
}));

export const StyledNormalText = styled(Typography)(({ theme }) => ({
  lineHeight: 1.2,
  [theme.breakpoints.up("xs")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.between('lg', 'xl')]: {
    fontSize: "18px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: "20px",
  },
}));
